import { Button, Paper, Text } from "@mantine/core";
import { useMemo, useState } from "react";
import DepositSummaryRow from "./DepositSummaryRow.tsx";
import { FieldDeposit } from "./types.ts";
import { formatCgt } from "./utils.ts";
import style from "./AsteroidField.module.css";

interface MaterialsSummaryProps {
  deposits: FieldDeposit[];
  totalDeposits: number | null;
  materialNames: Record<string, string>;
  lastFullImportAt: number | null;
}

export default function MaterialsSummary({ deposits, totalDeposits, materialNames, lastFullImportAt }: MaterialsSummaryProps) {
  const [visible, setVisible] = useState(true);

  const byType = useMemo(() => {
    return deposits.reduce<Record<string, FieldDeposit[]>>((acc, deposit) => {
      acc[deposit.type] = acc[deposit.type] || [];
      acc[deposit.type].push(deposit);
      return acc;
    }, {});
  }, [deposits]);

  const totalLabel = typeof totalDeposits === "number" ? ` / ${totalDeposits}` : "";

  return (
    <Paper p="sm" mt="sm" withBorder>
      <div className={style.summaryHead}>
        <Text fw={700}>Deposits ({deposits.length}{totalLabel})</Text>
        <Button size="compact-xs" variant="subtle" onClick={() => setVisible((v) => !v)}>
          {visible ? "Hide" : "Show"}
        </Button>
      </div>
      <Text size="xs" c="dimmed" mb="xs">
        Stability refresh baseline: {lastFullImportAt ? formatCgt(lastFullImportAt) : "unknown"}
      </Text>

      {visible ? (
        <table className={style.table}>
          <thead>
            <tr>
              <th>Type</th>
              <th>Total size</th>
              <th>Count</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {Object.keys(byType)
              .sort((a, b) => (materialNames[a] ?? a).localeCompare(materialNames[b] ?? b))
              .map((matType) => (
                <DepositSummaryRow
                  key={matType}
                  name={materialNames[matType] ?? matType}
                  deposits={byType[matType]}
                  lastFullImportAt={lastFullImportAt}
                />
              ))}
          </tbody>
        </table>
      ) : null}
    </Paper>
  );
}
